import { Directive, inject } from '@angular/core';

import { COMMON_CLIENT_CONFIG } from '~ng-common-lib/core/tokens/client-config';

/**
 * Adds `ClientConfig.branding.tenantMarkIconClass` (main-icons glyph for this tenant).
 */
@Directive({
	selector: 'i[tenantMarkIconClass]',
	standalone: true,
	host: {
		'[class]': 'tenantIconClass',
	},
})
export class TenantMarkIconDirective {
	private readonly clientConfig = inject(COMMON_CLIENT_CONFIG);

	protected get tenantIconClass(): string {
		return this.clientConfig.branding.tenantMarkIconClass;
	}
}
